import React,{useEffect, useRef, useState} from 'react'
import DashboardMenu from './DashboardMenu';
import { GetUnreadNotificationService, MarkAllReadNotificationService, UpdateAllReadNotificationService } from '../../services/NotificationServices';
import moment from 'moment';
import ClientListChatCE from '../vehicle/ClientListChatCE';
import useScreenSize from '../../components/useScreenSize';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { TbSchoolBell } from "react-icons/tb";
import { BsViewList } from "react-icons/bs";
import ClientListCE from '../vehicle/ClientListCE';

function AdminChatWindow() {

  const { width, height } = useScreenSize()
  const navigate = useNavigate()


  const [data,setdata] = useState([]) 
  const [page,setpage] = useState(1)
  const [loading, setLoading] = useState(false);
  const listRef = useRef(null);

  
  const [selectedData,setselectedData] = useState({})
  

  useEffect(()=>{
    getData()
  },[page])

  async function getData(){
    setLoading(true);
    const response = await GetUnreadNotificationService(page)
    setdata(prev => ({
      datas: page === 1 
        ? response?.data?.datas 
        : [...(prev?.datas || []), ...(response?.data?.datas || [])],
      pagination: response?.data?.pagination,
    }));

    setLoading(false);
  }

  async function handleDataSelect(d) {
    setselectedData(d);
    if (width < 768) {
      navigate('/clients/list/edit', { state: d?.customer });
    }

    setdata(prev => ({
      ...prev,
      datas: prev?.datas?.map(d1 =>
        d1?._id === d?._id
          ? { ...d1, read: true, unreadCount: 0 }
          : d1
      ),
      pagination: prev?.pagination,
    }));

    let sendData = {customer:d?.customer?._id}
    await UpdateAllReadNotificationService(sendData)
  }
  

  async function markAllAsRead() {
    const response = await MarkAllReadNotificationService({})
    if(response){
      setpage(1)
      getData()
    }
    toast.success("All Marked as Read")
  }




  console.log("Data",data)

  return (
    <div className='md:flex relative md:h-screen md:max-h-screen md:overflow-y-hidden pt-0 md:pt-0'>
        
        <DashboardMenu />
        <div className='md:w-[87%] flex pt-2 md:pt-2'>
            <div  ref={listRef} className='md:min-w-[22%] px-2 md:max-w-[22%] border-r md:h-screen md:max-h-screen md:overflow-y-scroll'
              onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.target;
              const bottom = scrollTop + clientHeight >= scrollHeight - 10; // near bottom

              if (
                bottom &&
                !loading &&
                data?.datas?.length < data?.pagination?.total
              ) {
                page !== data?.pagination?.totalPages && setpage(prev => prev + 1);
              }
            }}
            >
                <div className='py-2 flex items-center justify-between cursor-pointer border-b'>
                   <h6 className='text-[12px] font-[800]'>Total Data : ({data?.pagination?.total})</h6>
                   <h6 onClick={markAllAsRead} className='bg-slate-100 cursor-pointer border rounded font-[600] w-max border-slate-300 text-[9px] px-1 py-1 '>Mark All Read</h6>
                </div>
                {data?.datas?.map((d)=>(
                  // ${(moment(d?.createdAt).isSame(moment(), 'day') && d?.unreadCount > 0) ? 'bg-yellow-100' : d?.unreadCount > 0 && 'bg-blue-100'}
                  <div onClick={()=>{handleDataSelect(d)}} className={`p-1 cursor-pointer relative border-b`}>
                     <h6 className='text-[13px] font-[700]'>{d?.customer?.name}</h6>
                     <h6 className='text-[12px] w-[90%]'>{d?.message}</h6>
                     {d?.unreadCount > 0 && <h6 className='absolute right-[10px] top-[20px] z-20 p-[4px] px-[6px] rounded-full bg-[#2a297e] text-white flex items-center text-center justify-center text-[6px]'>{d?.unreadCount}</h6>}
                     <h6 className='text-[11px] font-[600]'>Created Time : {moment(d?.createdAt).fromNow()}</h6>
                  </div>
                ))}

                {data?.datas?.length === 0 &&
                <div className='flex flex-col items-center justify-center my-10'>
                  <TbSchoolBell className='text-gray-400' size={70} />
                  <h6 className='text-[13px] mt-2 font-[700]'>No Notification Exist</h6>
                </div>  }
            </div>
            <div className='hidden md:block w-[78%]  relative h-full overflow-hidden bg-gray-50'>
             {selectedData?._id !== undefined && 
            //  <ClientListChatCE passData={selectedData} />
             <ClientListCE passData={selectedData} />
             }

             {selectedData?._id === undefined &&
              <div className='flex flex-col items-center justify-center my-10'>
                  <BsViewList className='text-gray-400' size={70} />
                  <h6 className='text-[13px] mt-2 font-[700]'>No Notification Selected</h6>
                  <h6 className='text-[12px] mt-2 w-[50%] text-center'>Selected the Notification from left side to get the customer detail to get interact with them!</h6>
                </div>
             }
            </div>
       
       </div>
       
    </div>
  )
}

export default AdminChatWindow